export const classes = {
  card: 'py-1 px-4 place-center shrink-0 rounded-3xl',
  title: 'text-sm text-grey-7 dark:text-mauve-2 font-medium whitespace-nowrap',
};
